import { Component } from '@angular/core';
import { MainsComponent } from '../../common/pages/mains/mains.component';
import { SettingService } from '../../common/services/setting/setting.service';
import { RentalsService } from '../../services/unit/rentals.service';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { SelectService } from '../../common/services/select/select.service';
import { BackurlService } from 'src/common/services/backurl/backurl.service';

@Component({
    selector: 'app-rentals',
    templateUrl: './rentals.component.html',
    styleUrls: ['./rentals.component.scss']
})
export class RentalsComponent extends MainsComponent {

    public filterBeds = [1, 2, 3, 4, 5];
    public preview: any = null;
    public paramInit: any = {};

    constructor(
        public setting: SettingService,
        public db: RentalsService,
        public select: SelectService,
        protected router: Router,
        protected fb: FormBuilder,
        public backURL: BackurlService,
    ) {
        super(setting, db, select, router, fb, backURL);

        Object.assign(this.paramInit, this.db.itemsPageConfig.mapParams);

        this.sortServerForm = this.fb.group({
            filters: this.fb.group({
                rentalRealtor: [this.db.selectRealtorFilter()],
                rentalAgency: [this.db.selectAgencyFilter()],
            }),
        });

        
        this.sortLocalForm = this.fb.group({
            multiFilters: this.fb.group({
                rentalStatus: [],
            }),
        });
    }

    goItem(item: any) {
        if (this.db.itemsPageConfig.sideTab === 1 && !this.select.active) {
            this.backURL.addURL(`/rentals/`);
            this.router.navigate([`/${this.db.moduleListName}/${item.$key}`]);
        } else {
            this.db.itemsPageConfig.sideTab = 1;
        }
    }

    toggleMap() {
        this.db.itemsPageConfig.map = !this.db.itemsPageConfig.map;
    }

    previewItem(item: any) {
        if (!(this.preview && item && item.$key === this.preview.$key)) {
            this.preview = null;
            setTimeout(() => {
                this.preview = item;
            }, 50);
        }
    }
}
